import { useState } from "react";
import { useAuthContext } from "../../context/AuthContext";
import HeaderXSm from "../Headers/HeaderXSm";
import InputLebelComponent from "../InputLebel/InputLebelComponent";
import { Button } from "react-bootstrap";
import { AlertDanger, AlertInfo, AlertSuccess } from "../Alerts/Alert";
import ScreenHeader from "../Headers/ScreenHeader";

//import API
import createClient from "../../apis/createClient";

const AddClientForm = () => {
  const { userDetails } = useAuthContext();
  const user_slug = JSON.parse(userDetails).user_slug;
  const user_primary_role = JSON.parse(userDetails).user_primary_role;

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [buttonText, setButtonText] = useState("Create Account");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [hasSubmitError, setHasSubmitError] = useState(false);
  const [isValidSubmit, setIsValidSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleFNChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleLNChange = (e) => {
    setLastName(e.target.value);
  };

  const displayMainContent = () => {
    return displayFormBlock();
  };

  const handleFormSubmit = () => {
    //disable signup button
    setIsButtonDisabled(true);

    //change signup button text while processing
    setButtonText("Processing, please wait...");

    //change alert block content
    setHasSubmitError(false);
    setErrorMessage(false);
    setIsValidSubmit(false);
    setSuccessMessage(false);

    //check for valid email
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    let isInvalid = 0;
    let errMessage = [];

    if (email.trim().length === 0) {
      isInvalid = 1;
      errMessage.push("Enter email address");
    } else {
      if (!emailPattern.test(email)) {
        isInvalid = 1;
        errMessage.push("Enter a valid email address");
      }
    }

    if (isInvalid === 1) {
      setErrorMessage(errMessage);
      setHasSubmitError(true);
      setIsButtonDisabled(false);
      setButtonText("Create Account");
    } else {
      submitForm();
    }
  };

  const submitForm = () => {
    let errMessage = [];
    let succMessage = [];

    let formData = {
      user_slug: user_slug,
      email: email,
      firstName: firstName.trim(),
      lastName: lastName.trim(),
    };

    try {
      createClient(formData).then(async (data) => {
        if (data?.data) {
          if (data.data.status === 1) {
            succMessage.push(data.data.message);
            setSuccessMessage(succMessage);
            setIsValidSubmit(true);
            setHasSubmitError(false);
            setIsButtonDisabled(true);
            setButtonText("Create Account");

            setTimeout(() => {
              window.location.replace("access-control");
            }, 1000);
          } else if (data.data.status === 0) {
            errMessage.push(data.data.message);
            setErrorMessage(errMessage);
            setHasSubmitError(true);
            setIsButtonDisabled(false);
            setButtonText("Create Account");
          } else {
            errMessage.push("Error happened. Unable to create client account.");
            setErrorMessage(errMessage);
            setHasSubmitError(true);
            setIsButtonDisabled(false);
            setButtonText("Create Account");
          }
        } else {
          errMessage.push("Error happened. Unable to create client account");
          setErrorMessage(errMessage);
          setHasSubmitError(true);
          setIsButtonDisabled(false);
          setButtonText("Create Account");
        }
      });
    } catch (error) {
      errMessage.push("Error happened. Network error happened.");
      setErrorMessage(errMessage);
      setHasSubmitError(true);
      setIsButtonDisabled(false);
      setButtonText("Create Account");
    }
  };

  const displayTopBlock = () => {
    return (
      <ScreenHeader
        title={"Create Client Access"}
        subText={"Provide your client with redacted access"}
      />
    );
  };

  const displayForm = () => {
    return (
      <div className="d-block">
        {displayLoginBlock()}
        {displaySubmitButton()}
        {displayStatusMessage()}
      </div>
    );
  };

  const displayLoginBlock = () => {
    return (
      <div className="card-custom">
        <HeaderXSm
          title={"Add account information"}
          subText={"Enter client email address to add"}
        />

        <div className="card-body">
          <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
            <div className="col-12 col-md-4 col-lg-4 col-xlg-4">
              <div className="form-input-holder">
                <InputLebelComponent title="Email Address" />
                <div className="d-block">
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    placeholder="Enter client email address"
                    onChange={handleEmailChange}
                    value={email}
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
            <div className="col-12 col-md-4 col-lg-4 col-xlg-4">
              <div className="form-input-holder">
                <InputLebelComponent title="First Name" />
                <div className="d-block">
                  <input
                    type="text"
                    className="form-control"
                    id="fname"
                    placeholder="Enter first name"
                    onChange={handleFNChange}
                    value={firstName}
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4 col-xlg-4">
              <div className="form-input-holder">
                <InputLebelComponent title="Last name" />
                <div className="d-block">
                  <input
                    type="text"
                    className="form-control"
                    id="lname"
                    placeholder="Enter last name"
                    onChange={handleLNChange}
                    value={lastName}
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const displaySubmitButton = () => {
    return (
      <div className="form-button-holder justify-content-end">
        <Button
          variant="primary"
          disabled={isButtonDisabled}
          onClick={handleFormSubmit}
          size={"md"}
        >
          {buttonText}
        </Button>
      </div>
    );
  };

  const displayStatusMessage = () => {
    return (
      <div className="d-block">
        {displayErrorMessage()} {displaySuccessMessage()}
      </div>
    );
  };

  const displayErrorMessage = () => {
    if (hasSubmitError) {
      return <AlertDanger title={"Oops"} message={errorMessage} />;
    }
  };

  const displaySuccessMessage = () => {
    if (isValidSubmit) {
      return <AlertSuccess title={"Success"} message={successMessage} />;
    }
  };

  const displayFormBlock = () => {
    if (user_primary_role === "2") {
      return (
        <>
          {displayTopBlock()}
          {displayForm()}
        </>
      );
    } else {
      return (
        <AlertInfo
          title={"Note"}
          message={"You do not have access to create Client"}
        />
      );
    }
  };

  return <div className="d-block">{displayMainContent()}</div>;
};

export default AddClientForm;
